import { render, staticRenderFns } from "./SystemConfigBuyKefuu.vue?vue&type=template&id=caf3dfaa&"
import script from "./SystemConfigBuyKefuu.vue?vue&type=script&lang=js&"
export * from "./SystemConfigBuyKefuu.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigBuyKefuu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports